import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createSlots as _createSlots, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["data-qe-id"]
const _hoisted_2 = {
  key: 0,
  class: "join-teaser"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "tournament-headline",
  "data-qe-id": "tournament-name"
}
const _hoisted_5 = {
  key: 1,
  "data-qe-id": "tournament-clearance-phase",
  class: "t-inlay-tip clearance-phase-inlay-tip t-tc"
}
const _hoisted_6 = {
  key: 2,
  class: "c-game-buttons-section"
}

import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import events from '@gd/event-bus'
import { useStore } from '@/store'

import { User } from '@gd/storage'
import CGamesOverview from '@/components/CGamesOverview.vue'
import CLobbyStatus from '@/components/CLobbyStatus.vue'
import CJoinedTemplate from '@/components/CJoinedTemplate.vue'
import CMastersRegistrationPanel from '@/components/tournamentsView/CMastersRegistrationPanel.vue'
import CTournamentRegistrationPanel from '@/components/tournamentsView/CTournamentRegistrationPanel.vue'
import CTournamentLaurel from '@/components/CTournamentLaurel.vue'
import { TOURNAMENT_LAUREL_STATE as _TOURNAMENT_LAUREL_STATE } from '@/components/CTournamentLaurel.vue'
import MTournamentRegistration from '@/modules/MTournamentRegistration.vue'
import { Tournament, TournamentUi, GameUi } from '@/model/Tournament'
import MResultModal from '@/modules/MResultModal.vue'
import { Getters } from '@/store/getters'
import { TournamentStatus as _TournamentStatus } from '@/model/TournamentStatus'


export default /*@__PURE__*/_defineComponent({
  __name: 'MTournament',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const router = useRouter()
const store = useStore()
const { t } = useI18n()
const tournamentRegistration = ref(null)
const TournamentStatus = _TournamentStatus
const gameSelectedCompetitionId = ref('')
const showResultModal = ref(false)
const TOURNAMENT_LAUREL_STATE: any = _TOURNAMENT_LAUREL_STATE

const tournamentName = computed(() => {
  return (store.getters.tournamentUi as TournamentUi).name
})

const tournamentImage = computed(() => {
  // return (store.getters.tournamentUi as TournamentUi).metaData.image || null
  return null
})

const games = computed(() => {
  return (store.getters as Getters).tournamentUi.games
})
/**
 * all games are played
 */
const allGamesPlayed = computed(() => {
  return (store.getters as Getters).tournamentUi.allGamesPlayed
})

const hasNextGame = computed(() => {
  return (store.getters as Getters).tournamentUi.hasNextGame
})

/**
 * The "tournamentUi.isLobbyOpen" doesn't consider if the competition is running
 */
const isLobbyOpen = computed(() => {
  const tournamentUi = (store.getters as Getters).tournamentUi
  return (
    tournamentUi.tournamentStatus === TournamentStatus.RUNNING &&
    tournamentUi.lobbyTimers.start.totalSecs === 0 &&
    tournamentUi.lobbyTimers.end.totalSecs > 0
  )
})

const tournament = computed((): Tournament => {
  return store.state.tournament
})

const tournamentUi = computed((): TournamentUi => {
  return store.getters.tournamentUi
})

function register(rejoin: boolean, block?: boolean) {
  if (block) {
    return
  }

  if ((store.state.user as User).forcePayout) {
    router.replace('/extern/payout')
    return
  }
  tournamentRegistration.value.show({ rejoin })
}

function onRegistrationComplete() {
  events.$emit('update-balance')
  store.dispatch('ranking/tournament/fetch', tournament.value.tournamentId)
  if (tournamentUi.value.isMasters) {
    store.dispatch('ranking/season/fetch', store.state.zone.zoneId)
  }
}

function onGame(game: GameUi) {
  gameSelectedCompetitionId.value = game.competitionId
  showResultModal.value = true
  //  // for the first tournament version we don't have a click functionality on the games
  //  // - this will be added later - so keep the code which opens the gameStats
  // this.loadingGamesStats = true
  // showGameStats.value = true
  // store
  //   .dispatch('history/fetchGameHistoryById', game.competitionId)
  //   .then(() => {
  //     this.loadingGamesStats = false
  //     console.log(
  //       `Fetched game history for game ${
  //         game.competitionId
  //       }. Now switch into game history view to display retrieved data.`
  //     )
  //   })
  //   .catch((err: Error) => {
  //     this.loadingGamesStats = false
  //     console.warn(err)
  //   })
}

function playGame(blocked: boolean) {
  if (blocked || !hasNextGame.value || !isLobbyOpen.value) {
    return
  }
  router.push(`/matching/${store.state.zone.zoneId}/${(store.state.tournament as Tournament).tournamentId}`)
}

function onLobbyTimerComplete() {
  store.dispatch('fetchTournament', store.state.zone.zoneId).catch((err: any) => {
    if (err === 401) {
      router.replace('/extern/login')
    }
  })
}

const userName = computed((): string => {
  return store.state.user.name
})
const rejoinLimitReached = computed((): boolean => {
  const tournament: Tournament = store.state.tournament
  return !tournament.metaData.rejoinsUnlimited && tournament.metaData.rejoinsRemaining === 0
})
const rejoinTooltipText = computed(() => {
  if (registrationIsOver.value) {
    return t('tViews.joined.button_rejoin_tooltip_registrationTimeOver')
  }
  if (rejoinLimitReached.value) {
    return t('tViews.joined.button_rejoin_tooltip_rejoinLimitReached')
  }
  return t('tViews.joined.button_rejoin_tooltip_noGamesPlayed')
})
const rejoinNotPossible = computed((): boolean => {
  const tournament: Tournament = store.state.tournament
  return tournament.games.length === 0 || rejoinLimitReached.value || registrationIsOver.value
})
/**
 * the case that the registration time ended and a tournament is not
 * in running mode is not handled ( because it should not happen )
 */
const registrationIsOver = computed(() => {
  return !(
    tournamentUi.value.isRegistrationPossible || tournamentUi.value.tournamentStatus === TournamentStatus.UPCOMING
  )
})

return (_ctx: any,_cache: any) => {
  const _component_t_container = _resolveComponent("t-container")!
  const _component_t_text = _resolveComponent("t-text")!
  const _component_t_button = _resolveComponent("t-button")!
  const _component_t_tooltip = _resolveComponent("t-tooltip")!
  const _component_c_tech_hint = _resolveComponent("c-tech-hint")!

  return (_openBlock(), _createElementBlock("div", {
    class: "tournament",
    "data-qe-id": `tournament-${tournament.value.joined ? 'overview' : 'registration'}`
  }, [
    (!tournament.value.joined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (tournamentUi.value.tournamentStatus !== _unref(TournamentStatus).FINISHED)
            ? (_openBlock(), _createBlock(CLobbyStatus, {
                key: 0,
                class: "lobby-status",
                timers: tournamentUi.value.lobbyTimers,
                onLobbyTimerComplete: onLobbyTimerComplete,
                "is-banner": ""
              }, null, 8, ["timers"]))
            : _createCommentVNode("", true),
          _createVNode(_component_t_container, null, {
            default: _withCtx(() => [
              (tournamentUi.value.isMasters)
                ? (_openBlock(), _createBlock(CMastersRegistrationPanel, {
                    key: 0,
                    tournamentUi: tournamentUi.value,
                    onRegister: _cache[0] || (_cache[0] = ($event: any) => (register(false)))
                  }, null, 8, ["tournamentUi"]))
                : (_openBlock(), _createBlock(CTournamentRegistrationPanel, {
                    key: 1,
                    tournamentUi: tournamentUi.value,
                    onRegister: _cache[1] || (_cache[1] = ($event: any) => (register(false)))
                  }, null, 8, ["tournamentUi"]))
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_t_text, { class: "tournament-header" }, {
            default: _withCtx(() => [
              (tournamentImage.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: tournamentImage.value,
                    class: "tournament-image",
                    "data-qe-id": "tournament-image"
                  }, null, 8, _hoisted_3))
                : _createCommentVNode("", true),
              _createElementVNode("h1", _hoisted_4, _toDisplayString(tournamentName.value), 1),
              _createElementVNode("span", {
                class: "winning-distribution-info",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(events).$emit('tournament-info-modal', { tournamentUi: tournamentUi.value, trackId: 'header' }))),
                "data-qe-id": "win-distribution-trigger"
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("i", { class: "icf-info icon-info" }, null, -1)
              ]))
            ]),
            _: 1
          }),
          _createVNode(CJoinedTemplate, {
            isMasters: tournamentUi.value.isMasters,
            class: "joined-template"
          }, {
            default: _withCtx(() => [
              (tournamentUi.value.tournamentStatus !== _unref(TournamentStatus).FINISHED)
                ? (_openBlock(), _createBlock(CLobbyStatus, {
                    key: 0,
                    class: "lobby-status",
                    timers: tournamentUi.value.lobbyTimers,
                    onLobbyTimerComplete: onLobbyTimerComplete,
                    "is-banner": ""
                  }, null, 8, ["timers"]))
                : _createCommentVNode("", true),
              _createVNode(CGamesOverview, {
                onOnGame: onGame,
                games: games.value
              }, _createSlots({ _: 2 }, [
                (tournament.value.tournamentRank)
                  ? {
                      name: "header",
                      fn: _withCtx(() => [
                        _createVNode(CTournamentLaurel, {
                          class: "tournament-laurel",
                          state: allGamesPlayed.value ? _unref(TOURNAMENT_LAUREL_STATE).FINISHED : _unref(TOURNAMENT_LAUREL_STATE).RUNNING,
                          score: tournament.value.games.length > 0 ? tournament.value.tournamentScore : '-',
                          rank: tournament.value.tournamentRank,
                          "prev-best-score": _unref(store).state.ranking.tournament.prevBestScore
                        }, null, 8, ["state", "score", "rank", "prev-best-score"])
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["games"]),
              (tournament.value.metaData.clearancePhase)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('tViews.joined.clearance_info')), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (!allGamesPlayed.value)
                      ? (_openBlock(), _createBlock(_component_c_tech_hint, {
                          key: 0,
                          techs: tournament.value.metaData.gameTechs,
                          gametype: tournamentUi.value.gametype,
                          class: "c-game-button"
                        }, {
                          default: _withCtx((status) => [
                            _createVNode(_component_t_tooltip, {
                              disabled: !(!hasNextGame.value || !isLobbyOpen.value) || status.block,
                              text: _ctx.$t('tViews.joined.button_tooltip_' + (!isLobbyOpen.value ? 'lobbyClosed' : 'pending'))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_t_button, {
                                  inactive: status.block,
                                  disabled: !(hasNextGame.value && isLobbyOpen.value) && !status.block,
                                  onClick: ($event: any) => (playGame(status.block)),
                                  yellow: "",
                                  l: "",
                                  "data-qe-id": "play-button"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('tViews.joined.button_play')), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["inactive", "disabled", "onClick"])
                              ]),
                              _: 2
                            }, 1032, ["disabled", "text"])
                          ]),
                          _: 1
                        }, 8, ["techs", "gametype"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_c_tech_hint, {
                      techs: tournament.value.metaData.gameTechs,
                      gametype: tournamentUi.value.gametype,
                      class: "c-game-button",
                      skipCheck: rejoinNotPossible.value
                    }, {
                      default: _withCtx((status) => [
                        _createVNode(_component_t_tooltip, {
                          disabled: !rejoinNotPossible.value || status.block,
                          text: rejoinTooltipText.value,
                          class: "c-game-button"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_t_button, {
                              onClick: ($event: any) => (register(true, status.block)),
                              inactive: status.block,
                              disabled: rejoinNotPossible.value && !status.block,
                              gray: "",
                              l: "",
                              "data-qe-id": "rejoin-button"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('tViews.joined.button_rejoin')), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "inactive", "disabled"])
                          ]),
                          _: 2
                        }, 1032, ["disabled", "text"])
                      ]),
                      _: 1
                    }, 8, ["techs", "gametype", "skipCheck"])
                  ]))
            ]),
            _: 1
          }, 8, ["isMasters"])
        ], 64)),
    _createVNode(MTournamentRegistration, {
      onRegistrationComplete: onRegistrationComplete,
      ref_key: "tournamentRegistration",
      ref: tournamentRegistration
    }, null, 512),
    (showResultModal.value)
      ? (_openBlock(), _createBlock(MResultModal, {
          key: 2,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (showResultModal.value = false)),
          "competition-id": gameSelectedCompetitionId.value
        }, null, 8, ["competition-id"]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})